import { isNonEmptyArray } from '@/helpers/array-helpers'
import TimesheetsWeekGroupingListItem from './timesheetsWeekGroupingListItem'

export default class TimesheetsPrimaryGroupDisplayableItem {
  constructor(params) {
    /**
     * @type {Number}
     */
    this.id = params.id
    /**
     * @type {String}
     */
    this.name = params.name
    /**
     * @type {Number}
     */
    this.approvedCount = params.approvedCount ?? 0
    /**
     * @type {Number}
     */
    this.pendingReviewCount = params.pendingReviewCount ?? 0
    /**
     * @type {Number}
     */
    this.pendingApprovalCount = params.pendingApprovalCount ?? 0
    /**
     * Indicates if the displayable data for this group is completely pulled from backend
     * @type {Boolean}
     */
    this.isLoaded = params.isLoaded ?? false
    /**
     * Displayable data structure for the single primary group
     * @type {Array<TimesheetsWeekGroupingListItem>}
     */
    this.pendingApprovalDisplayable = isNonEmptyArray(
      params.pendingApprovalDisplayable
    )
      ? params.pendingApprovalDisplayable.map(
          (client) => new TimesheetsWeekGroupingListItem(client)
        )
      : []
  }
}
